import {
    SET_LEASE_VIEW,
    SET_LEASE_LOADING,
    UPDATE_LEASE_FIELD,
    SET_LEASE_ADDRESS_VALIDATION
} from "../types";

const initialState = {
    data: {},
    lists: {},
    contacts: {},
    view: {},
    addressValidation: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_LEASE_FIELD:
            return {
                ...state,
                data: payload
            };
        case SET_LEASE_VIEW:
            return {
                ...state,
                data: {
                    ...payload.data,
                    ...(payload.additional_data ? payload.additional_data : {})
                },
                contacts: payload.contacts,
                view: {
                    ...state.view,
                    skeleton: payload.skeleton,
                    dropdowns: payload.dropdowns,
                    validation_rules: payload.validation_rules
                }
            };
        case SET_LEASE_ADDRESS_VALIDATION:
            return {
                ...state,
                addressValidation: payload
            };
        default:
            return state;
    }
}
